// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 引用入口vue文件
import App from './App'
// 路由列表
import router from './router'
// store存储对象
import store from './store'
// http请求对象
import Axios from 'assets/js/myAxios'
// 引入Element UI
import ElementUI from 'element-ui'
// 引入公共filter
import 'assets/js/filters'
// 引入公共样式，包括element-ui的css
import 'assets/css/common.scss'
import 'assets/css/layout.scss'
// 引入iconfont.js绘制svg
import 'assets/js/iconfont'
// 引入Echarts图表组件
import ECharts from 'vue-echarts/components/ECharts.vue'
import 'echarts-gl'
// 引入数字动画组件
import AnimateNumber from 'vue-animate-number'

Vue.config.productionTip = false

Vue.prototype.$http = Axios
Vue.use(ElementUI)
Vue.component('chart', ECharts)
Vue.use(AnimateNumber)

// register global progress.
router.beforeEach((to, from, next) => {
  store.dispatch('setNavigation', []) // 重置面包屑导航
  // 判断是否有登录认证信息，并且未过期
  if (store.getters.authentication && new Date(store.getters.authentication.tokenExp) - new Date().getTime() > 0) {
    if (to.name === 'login') {
      next({ path: '/user/center' })
    } else {
      if (to.meta && to.meta.admin && !store.getters.authentication.isAdmin) {
        console.log(ElementUI.Message.error('没有管理员权限'))
        next({ path: '/user/center' })
      } else {
        store.dispatch('studyProgress') // 获取学习进度
        store.dispatch('getUnReadNoticeCount') // 获取未读通知数量
        next({ to }) // hack方法
      }
    }
  } else {
    if (to.name === 'login') { // 登录页，直接进入
      next()
    } else {
      next({ path: '/login' }) // 否则全部重定向到登录页
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js